export default "__VITE_ASSET__BbGgJv68__"